import { useStytchMemberSession } from '@stytch/react/b2b';

import { StytchLogin } from 'pages/StytchLogin';

import { useLoadingStore } from 'store/loading.store';

export function StytchAuthCallback() {
  const { loading } = useLoadingStore();
  const { session } = useStytchMemberSession();
  // Show global loader instead of local loading state
  if (loading) {
    return null; // Global Loader component in App.tsx will handle this
  }

  // If no session, show the login form again
  return session ? null : <StytchLogin />;
}
